// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1270":"1534ad9d6a83cadb","8727":"40cfb3b4643f594e"}[chunkId] + ".js";
};